import React from "react";
import { Outlet } from "react-router-dom";
import "./main-layout.scss";
import Header from "../header/header";

const MainLayout: React.FC = () => {
  return (
    <div className="main-layout">
      <Header />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
